import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setIsAskAIDrawerOpen } from "../../reducers/common-reducer";
import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import { useFlags } from "launchdarkly-react-client-sdk";
import { CALL_BODY_SCREEN } from "../../constants/Constants";

const AskAIButton = () => {
    const dispatch = useDispatch();
    const ldFlags = useFlags();
    const localisedValues = useLanguageChange();
    const { isAskAIDrawerOpen, isRemoteParticipantJoined, currentCallBodyScreen } = useSelector((state) => state.commonReducer);

    const handleClickOnAskAIButton = () => {
        dispatch(setIsAskAIDrawerOpen(!isAskAIDrawerOpen));
    };

    return (
        <>
            {GLOBAL_MEETING_DATA.isAgent && ldFlags.askAiAssistant && (
                <div className='action-button askai-action-button' id='askai-action-button'>
                    <div className='action-button-in'>
                        <button
                            className={clsx("call-action-btn open-sidebar-button", isAskAIDrawerOpen && "active")}
                            onClick={() => handleClickOnAskAIButton()}
                            disabled={!isRemoteParticipantJoined || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-ai'></span>
                            </span>
                            <span className='for-text'>{localisedValues?.ask_ai}</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default AskAIButton;
